import React from 'react';

import { currencyRangeColumn, dateColumn } from '../utils/column-helpers';
import { ownerLink, salesTeamColumn, salesUnitColumn } from '../utils/columns';
import { agreementTypes } from './constants';
import { AgreementLink } from './Link';
import SimpleAgreementBudgetProgress from './SimpleAgreementBudgetProgress';

export const salesUnit = salesUnitColumn('salesUnit');
export const salesTeam = salesTeamColumn('salesTeam');

const name = {
  Header: 'Name',
  accessor: 'name',
  width: 200,
  Cell: row => <AgreementLink model={row.original} />,
};

const status = {
  Header: 'Status',
  id: 'status',
  filterable: false,
  sortable: false,
  accessor: 'budget',
  width: 125,
  className: 'pr-3',
  Cell: row => <SimpleAgreementBudgetProgress agreement={row.original} />,
};

const type = {
  Header: 'Type',
  accessor: agreement =>
    agreementTypes.find(a => a.value === agreement.type).label,
  id: 'type',
  width: 200,
};

const spendableBudget = currencyRangeColumn({
  Header: 'Spendable budget',
  accessor: 'budget',
  id: 'budget',
  width: 110,
});

const agreedBudget = currencyRangeColumn({
  Header: 'Agreed budget',
  accessor: 'agreedBudget',
  id: 'agreedBudget',
  width: 110,
});

const usedBudget = currencyRangeColumn({
  Header: 'Used budget',
  accessor: agreement => agreement.agreedBudget + agreement.plannedBudget,
  id: 'usedBudget',
  width: 110,
});

const openBudget = currencyRangeColumn({
  Header: 'Open budget',
  accessor: agreement =>
    agreement.budget - agreement.agreedBudget - agreement.plannedBudget,
  id: 'openBudget',
  width: 110,
});

const startDate = dateColumn('Start', 'startDate', 95);
const endDate = dateColumn('End', 'endDate', 95);

const emptyColumn = width => ({
  Header: '',
  id: 'empty',
  filterable: false,
  sortable: false,
  accessor: 'empty',
  width,
});

export const allColumns = [
  name,
  status,
  type,
  spendableBudget,
  agreedBudget,
  usedBudget,
  openBudget,
  startDate,
  endDate,
  salesUnit,
  salesTeam,
  ownerLink,
];

export const listColumns = [
  name,
  status,
  type,
  spendableBudget,
  openBudget,
  startDate,
  endDate,
  salesUnit,
  salesTeam,
  ownerLink,
];

export const accountColumns = [
  name,
  type,
  emptyColumn(265),
  spendableBudget,
  openBudget,
  startDate,
  endDate,
  salesUnit,
  salesTeam,
  ownerLink,
];

export const selectColumns = allColumns;
